import { TenderOfferParticipant } from 'types';
import { tenderParticipantStatusTypes } from 'utils/tenderOfferTypes';

type GetSoldUnits = {
  participant?: TenderOfferParticipant;
};

export const getSoldUnits = ({ participant }: GetSoldUnits): number => {
  if (!participant) return 0;

  if (participant.status === tenderParticipantStatusTypes.ACCEPTED.value) {
    return participant.totalAccepted;
  }

  return 0;
};
